import axios from 'axios';
import { axiosInstance } from '../Axios';
const { createSlice } = require('@reduxjs/toolkit');

const HotelReducer = createSlice({
	name: 'Hotel',
	initialState: {
		success: false,
		error: null,
		orderID: null,
		loadinghotel: false,
		loadinghoteldes: false,
		hotelcity: null,
	},
	reducers: {
		cityHotelRequest(state, action) {
			state.loadinghotel = true;
		},
		cityHotelSuccess(state, action) {
			state.loadinghotel = false;
			state.hotelcity = action.payload;
			state.error = null;
		},
		cityHotelFail(state, action) {
			state.loadinghotel = false;
			state.error = action.payload;
		},
	},
});
const config = {
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		'Client-Service': 'srk-client',
		'Auth-Key': 'srkapi',
		'Api-Key': 'NjO7hqe3PG9musafi==',
	},
};
const { actions } = HotelReducer;

export const { cityHotelRequest, cityHotelSuccess, cityHotelFail } = actions;

export const fetchHotelCityDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(cityHotelRequest());
		const { data } = await axiosInstance.post(
			'home/hotelcity',
			bodyData,
			config
		);
		console.log(data);
		dispatch(cityHotelSuccess(data));
	} catch (error) {
		dispatch(
			cityHotelFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};

export default HotelReducer;
